import PieChartDataViewer from "./PieChartDataViewer.js";
import PieChartViewModel from "./models/PieChartViewModel.js";
import PieChartViewEditor from "./editors/PieChartViewEditor.js";
import { EditPieChartContainerSettingsAction } from "./actions/index.js";
import PieChartSupportDataViewer from "./PieChartSupportDataViewer.js";
export default {
  install(molten) {
    molten.addPlugin('Action', EditPieChartContainerSettingsAction);
    molten.addPlugin('DataViewer', PieChartDataViewer);
    molten.addPlugin('DataViewer', PieChartSupportDataViewer);
    molten.addPlugin('Model', PieChartViewModel);
    molten.addPlugin('ModelEditor', {
      type: PieChartViewModel.TYPE,
      editor: PieChartViewEditor
    });
  }
};